// extracted by mini-css-extract-plugin
module.exports = {"message-content":"message-content__0O12f","message-content--reverse":"message-content--reverse__gS9lU"};